/* eslint-disable no-bitwise */
import React, { Component } from 'react'
import { Col, FormGroup ,Label, Badge } from "react-bootstrap";
import { Field, reduxForm, propTypes,formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import moment from 'moment'
import {
  saveLaneConditionsInfo,
  savingLaneConditions,
	resetWizardState,
	setOilRatio,
	initOilRatio,
} from '../../../../redux/actions/action_event';
import {
	blue,
	gray,
	forms,
	style,
	eventtypesEnum,
	oilratiotypesEnum,
	oilRatioFrequencyEnum,
    warning,
    StatusDescription
} from '../../../../utils/constants';
import { onlypositivenumbers } from '../../../../utils/functions';
import { renderFormattedField } from '../../../../modules/components/formattedfield'
import { renderOptionsField } from '../../../../modules/components/fieldoptioncomponent'
import { STEP_SEQUENCE } from '../../logic';
import fields from './fields'

const sectionBorder = {
	border:`1px solid ${gray}`,
	padding:'15px',
	marginRight:'0px',
	marginBottom:'15px'
}

const FormName = forms.eventinfo
class LaneConditions extends Component {

	static propTypes = {
		...propTypes
	}
	constructor(props) {
		super(props);
		this.state ={
			isTournamentEvent:true,
			isLeagueEvent:false,
			duration:null,
			dates:'',
			durationLabel:'',	
		}
		this.generateTournamentInput = this.generateTournamentInput.bind(this);
		this.generateLeagueInput = this.generateLeagueInput.bind(this);
		this.renderOilConditionField = this.renderOilConditionField.bind(this);
		this.saveEventLaneConditions = this.saveEventLaneConditions.bind(this);
		this.inputRatios = this.inputRatios.bind(this);
		this.setOilRatioSize = this.setOilRatioSize.bind(this);
		this.setOilRatioSizeWeekly = this.setOilRatioSizeWeekly.bind(this);
		this.generateUpdateErrors = this.generateUpdateErrors.bind(this);
	}
	componentWillMount() {
		const { startdate,enddate,eventtype, numberofweeks } = this.props;
		const eventTypes = Object.getOwnPropertyNames(eventtypesEnum)
		const isTournamentEvent = eventTypes[eventtype] === eventTypes[3]
		const duration = isTournamentEvent === true ? moment(enddate).diff(moment(startdate),'days') + 1 : numberofweeks;
		const durationLabel = (isTournamentEvent === true) ? 'Event number of days':'Event number of weeks';
		const isLeagueEvent = !isTournamentEvent;		
		this.setState({
			isTournamentEvent,
			duration,
			durationLabel,
			isLeagueEvent,
		});	
	}
	componentDidMount() {
		window.scrollTo(0, 0)
		this.props.dispatch(resetWizardState(STEP_SEQUENCE.LaneConditions));
	}
	
  renderOilConditionField(fieldname, key) {
    const { roleName, status } = this.props;
    const isAdministrator = roleName == 'Administrator';
		return ( 
			<Field
				key={key * 4}
				name={fieldname}
				id={key}
				component = { renderFormattedField }
				placeholder = '##.##'
				inputattrs = { style.inputattrs3 }
				options = { style.oilfieldoptions }
        disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
			/>)
	}  
  inputRatios(daily, oil, frequencyLabel) {
    const { roleName, status } = this.props;
    const  day = (oil !== undefined) ? oil.day:1;
		const arrayElement = day - 1;
		const ratiotypefld = `oilRatio[${arrayElement}].condition`;
    const ratiovaluefld = `oilRatio[${arrayElement}].ratio`;
    const isAdministrator = roleName == 'Administrator';

		return(
			<Col sm={12} style={{ border:`1px solid ${gray}`, padding:'15px', marginRight:'0px', marginBottom:'15px', maxHeight:'75px' }} key={day*2}>
				{	
					daily && (<FormGroup className='col-sm-1'  style={{ marginLeft:'1%', color:blue, marginTop:'0px', fontWeight:'bold', fontSize:'14px', padding:'0', maxWidth:'120px' }} key={day * 5}>
						<span style={{ textDecoration:'underline' }}>{frequencyLabel} {day}</span>
					</FormGroup>)
				}
				<FormGroup  className='col-sm-11' style={{ margin:"0px" }} key={day*6}>
					<Field
						inputattrs = {style.inputattrs6}
						name={ratiotypefld}
						id={arrayElement}
						key={arrayElement}
						values={[
							{ name:"Standard", abbreviation: oilratiotypesEnum.Standard, color:'green' },
							{ name:"Challenge", abbreviation:oilratiotypesEnum.Challenge, color:'blue'  },
							{ name:"Sport", abbreviation:oilratiotypesEnum.Sport, color:'red'  },
						]} 
						component={renderOptionsField}
            defaultvalue={ratiotypefld}
            disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
					/>
				</FormGroup>
        <FormGroup className='col-sm-2' style={{ padding: '0', marginLeft: '-50%', marginTop: '-15px' }} key={day * 7}>
          <label className={style.lblattrs1} style={{ color: blue }}>Ratio:</label>
          {
            this.renderOilConditionField(ratiovaluefld, arrayElement)
					}
				</FormGroup>
			</Col>)	
	}
	setOilRatioSize(duration) {
		const { oilRatio, dailyoilratios,dispatch } = this.props;
		if(dailyoilratios === 'false') 
		{
			if((oilRatio === undefined) || (oilRatio.length !== 1)) {
				dispatch(initOilRatio(1));
			}
		}
		else
		{
			if((oilRatio === undefined) || (oilRatio.length !== duration)) {
				dispatch(initOilRatio(duration));
			}
		}
	}
	setOilRatioSizeWeekly(duration) {
		const { oilRatio,weeklyOilRatios,dispatch } = this.props;
		if(weeklyOilRatios === 'false') 
		{
			if((oilRatio === undefined) || (oilRatio.length !== 1)) {
				dispatch(initOilRatio(1));
			}
		}
		else
		{
			if((oilRatio === undefined) || (oilRatio.length !== duration)) {
				dispatch(initOilRatio(duration));
			}
		}
	}
	generateTournamentInput() {
		const { duration } = this.state;
		const { dailyoilratios , oilRatio } = this.props;
		const _this = this;
		const daily = ((dailyoilratios === 'true') || (dailyoilratios === true));
		return(
			<div>
				{
					this.setOilRatioSize(duration)
				}
				{
					daily && oilRatio.map((oil) => {
						return _this.inputRatios(daily,oil,	oilRatioFrequencyEnum.Daily);
					})
				} 
				{
					!daily  && this.inputRatios(daily,oilRatio[0],oilRatioFrequencyEnum.Daily)
				}
			</div> 	
		);
	}
	generateLeagueInput() {
		const { duration } = this.state;

		const {
			weeklyOilRatios,
			weeklyOilRatiosChangesAfter,
            oilRatio,
            roleName,
            status
		} = this.props;

		const _this = this;
		const weekly = ((weeklyOilRatios === 'true') || (weeklyOilRatios === true));
		const differentWeeks = weekly === true ? (weeklyOilRatiosChangesAfter !== null && weeklyOilRatiosChangesAfter !== undefined && weeklyOilRatiosChangesAfter !== '') ? (Math.ceil(duration/parseInt(weeklyOilRatiosChangesAfter,10)) | 0):duration:duration;
    const isAdministrator = roleName == 'Administrator';

		return(
			<div>			
				{
					weekly && 
					(<Col sm={12} style={{ border:`1px solid ${gray}`, padding:'15px' , marginRight:'0px', marginBottom:'15px', maxHeight:'950px' }}> 
					<FormGroup className='col-sm-9'>
					<label className={style.lblattrs6}>After how many weeks does oil ratio change?&nbsp;</label>
					<Field
						type='number'
						name='weeklyOilRatiosChangesAfter'
						component='input'
						className="form-control no-spinners col-sm-1"
						style={{ maxWidth: '50px' }} 
						placeholder='##' 
						onKeyDown={onlypositivenumbers}
            disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
					/>
				</FormGroup></Col>)
				}
				{
					this.setOilRatioSizeWeekly(differentWeeks)
				}
				{
					weekly && oilRatio.map((oil) => {
						return _this.inputRatios(weekly,oil,oilRatioFrequencyEnum.Weekly);
					})
				} 
				{
					!weekly  && this.inputRatios(weekly,oilRatio[0],oilRatioFrequencyEnum.Weekly)
				}
			</div> 	
		);
	}
	saveEventLaneConditions() {
		const { dispatch,eventId, oilRatio, dailyoilratios, weeklyOilRatios, weeklyOilRatiosChangesAfter, seasons, eventseason, eventtype } = this.props
		const season = _.find(seasons, { id:parseInt(eventseason) });
		const laneConditions = {
			oilRatio:oilRatio,
			dailyOilRatios:dailyoilratios,
			weeklyOilRatios:weeklyOilRatios,
			weeklyOilRatiosChangesAfter:weeklyOilRatiosChangesAfter,
			step:3,
			season,
			eventtype
		}
		dispatch(saveLaneConditionsInfo(eventId, laneConditions));
	}

	generateUpdateErrors(laneConditionsErrors)
	{
		const error = laneConditionsErrors.map((key,index) => {
			return (<li key={index} style={{ color:warning }}>{this.props.updateLaneErrors[key]}</li>)
		})
		return error;
	}

	render() {
		const {
			eventname,
			handleSubmit,
			saveComponentState,
			componentStateSaved,
			currentWizardStep,
			dailyoilratios,
			weeklyOilRatios,
      updateLaneErrors,
      roleName,
      status
		} = this.props;
		
		const {
			isTournamentEvent,
			isLeagueEvent,
			duration,
			dates,
			durationLabel,	
		} = this.state;

    const isAdministrator = roleName == 'Administrator';
		const laneConditionsErrors = Object.keys(updateLaneErrors);
	
		if(currentWizardStep === STEP_SEQUENCE.LaneConditions)
		{      
			if((saveComponentState === true) && (componentStateSaved === false))
			{
				this.saveEventLaneConditions();
			}
			if(componentStateSaved === true)
			{
				this.props.onComponentStateSaved(componentStateSaved)
			}
			if(laneConditionsErrors.length > 0)
			{
				this.props.onComponentStateSaved(false)
			} 
		}
		return (
			<div style={{ marginTop:'1%' }} sm={12} >
				<form id='eventinfo' onSubmit={handleSubmit} className="form-horizontal" sm={6}>
				{
					laneConditionsErrors.length > 0 && 
					(<Col sm={12} style={sectionBorder}>
							<h4 style={{ color: warning }}>* Please correct the following errors to proceed:</h4>
							<ul>
							{
								this.generateUpdateErrors(laneConditionsErrors)
							}
							</ul>
						</Col>)
				}
					<Col sm={12} style={{ border:`1px solid ${gray}`, padding:'15px' , marginRight:'0px', marginBottom:'15px', maxHeight:'950px' }}> 
						<FormGroup style={{ paddingLeft:'15px', paddingBottom:'0', marginBottom:'20px' }}>
							<h4 className='col-sm-12' style={{ color:blue }}>{' '}Event Name - <span>{_.startCase(_.toLower(eventname))}</span></h4>              
						</FormGroup>											
						{
							(<FormGroup style={{ paddingLeft:'15px', paddingBottom:'0', marginBottom:'20px' }}>
								<label className={style.lblattrs} style={{ color: blue, fontWeight:'bold' }}>{durationLabel}</label>
								<Col sm={1}>                               
									<Label className="form-control" style={{ padding:'10px' }}><Badge  style={{ color:'black', fontSize:'120%', padding:'10px' }}>{duration} {'  '} {dates}</Badge></Label>
								</Col>
							</FormGroup>)
						}
						{isTournamentEvent &&
							<FormGroup>
								<Field
									label='Different oil ratios each day?'
									labelattrs = {style.lblattrs5}
									inputattrs = {style.inputattrs4}
									name='dailyOilRatios'
									id='dailyOilRatios'
									values={[
										{ name:"Yes", abbreviation:'true' },
										{ name:"No", abbreviation:'false'  },
									]}
									defaultvalue={dailyoilratios}
									component={renderOptionsField}
                  disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
								/>
							</FormGroup>
						}
						{ isLeagueEvent &&
							<FormGroup>
								<Field
									label='Does your event offer different oil ratio?'
									labelattrs = {style.lblattrs5}
									inputattrs = {style.inputattrs4}
									name='weeklyOilRatios'
									id='weeklyOilRatios'
									values={[
										{ name:"Yes", abbreviation:'true' },
										{ name:"No", abbreviation:'false'  },
									]}
									defaultvalue={weeklyOilRatios}
									component={renderOptionsField}
                  disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
								/>
							</FormGroup>
						}
					</Col>
						{	
							isTournamentEvent &&
							this.generateTournamentInput() 
						}
						
						{ 
							isLeagueEvent && 
							this.generateLeagueInput()
						}					
				</form>
			</div>)
	}
}
function mapStateToProps(state,ownProps) { 
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const dailyoilratios = selector(state,fields.DAILYOILRATIOS)
	const weeklyOilRatios = selector(state,'weeklyOilRatios')
	const weeklyOilRatiosChangesAfter = selector(state,'weeklyOilRatiosChangesAfter')
	const maxeventduration = selector(state,'maxeventduration')
	const startdate = selector(state,'startdate')
	const enddate   = selector(state,'enddate')
	const eventId   = selector(state,'eventId')
	const eventname = selector(state,'eventname')
  const eventtype = selector(state, 'eventType')
  const numberofweeks = selector(state, 'numberOfWeeks')
	const componentStateSaved = selector(state,'componentStateSaved')
	const currentWizardStep = selector(state,'currentWizardStep')
	const oilratiosetting = selector(state,'oilratiosetting')
	const oilRatio = selector(state,'oilRatio')
	const eventSeasonSettings = selector(state,'eventSeasonSettings')
	const seasons	= selector(state,'seasons')
	const eventseason	= selector(state,'eventseason')
  const updateLaneErrors = selector(state, 'updateLaneErrors')
  const status = selector(state, 'status')
  const roleName = state.user.roleName
  return {
		eventname,
		dailyoilratios,
		weeklyOilRatios,
		weeklyOilRatiosChangesAfter,
		maxeventduration,
		startdate,
		enddate,
    eventtype,
    numberofweeks,
		eventId,	
		componentStateSaved,
		currentWizardStep,
		oilratiosetting,
		oilRatio,	
		eventSeasonSettings,
		seasons,
		eventseason,
    updateLaneErrors,
    roleName,
    status
	}
}
function mapDispatchToProps(dispatch) { 
	return bindActionCreators({
    saveLaneConditionsInfo,
    savingLaneConditions,
		setOilRatio,
		initOilRatio,
	},dispatch)
}
LaneConditions.propTypes = {
	handleSubmit: PropTypes.func,
	previousPage:PropTypes.func,
	dispatch:PropTypes.func,
	saveLaneConditionsInfo: PropTypes.func,
	setOilRatio:PropTypes.func,
	initOilRatio:PropTypes.func,
	dailyoilratios: PropTypes.string,
	weeklyOilRatios: PropTypes.string,
	weeklyOilRatiosChangesAfter: PropTypes.string,
	oilRatio: PropTypes.array,
	maxeventduration:  PropTypes.number,
	startdate:PropTypes.string,
	enddate:PropTypes.string,
	eventId:PropTypes.number,
	eventname: PropTypes.string,
  eventtype: PropTypes.string,
  numberofweeks: propTypes.number,
	lanecondition:  PropTypes.string,
	onComponentStateSaved: PropTypes.func,
	componentStateSaved: PropTypes.bool,
	saveComponentState:PropTypes.bool,
	currentWizardStep: PropTypes.number,
	oilratiosetting: PropTypes.object,
	eventSeasonSettings:PropTypes.object,
	eventseason: PropTypes.string,
	seasons: PropTypes.array,
  updateLaneErrors: PropTypes.object,
  roleName: PropTypes.string,
  status: PropTypes.string,
  disabled: PropTypes.bool
}

export default reduxForm({
	form:FormName,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(LaneConditions))



// WEBPACK FOOTER //
// ./src/containers/event/components/laneConditions/index.js